import * as React from 'react';
import { Guid } from '../../infrastructure/Guid';

export interface RadioButtonProps {
    displayText: string;
    value: string;
    checked?: boolean;
    disabled?: boolean;
    onChange: (selectedValue: string) => void;
}

export default class RadioButton extends React.Component<RadioButtonProps, any> {
    private _id: string;

    constructor(props: RadioButtonProps) {
        super(props);
        this._id = Guid.newGuid();
    }

    render() {
        return (
            <div>
                <input
                    type='radio'
                    value={this.props.value}
                    checked={this.props.checked}
                    onChange={() => this.props.onChange(this.props.value)}
                    disabled={this.props.disabled}
                    id={this._id}
                    name={this._id}
                />
                <label htmlFor={this._id}>{this.props.displayText}</label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/input/RadioButton.tsx